import { hasRole } from '../../../utils/userRoles';
import { futureDateEditRoles } from '../utils/calendarUtils';

import {
    checkDiff,
    checkForPastDate,
    validateAdviser,
    validateAppointmentType,
    validateDate,
    validateEndTime,
    validateLocation,
    validateReferralDate,
    validateStartTime
} from './validationFunctions';

export const validate = (newEntry, initialStateOnEntry, referralDates = [], roles) => {
    let newErrors = {};
    newErrors = validateAppointmentType(newEntry.typeId, newErrors);
    newErrors = validateAdviser(newEntry.userId, newErrors);
    newErrors = validateLocation(newEntry.locationId, newErrors);
    newErrors = validateStartTime(newEntry.startTime, newEntry.endTime, newErrors);
    newErrors = validateEndTime(newEntry.endTime, newEntry.startTime, newErrors);
    newErrors = validateDate(newEntry.date, newErrors);
    if (hasRole(futureDateEditRoles, roles) && newEntry.date !== initialStateOnEntry.date)
        newErrors = checkForPastDate(newEntry.date, newErrors);
    if (newEntry.date && newEntry.participantIds.length) {
        referralDates.forEach((el) => {
            const errors = validateReferralDate(newEntry.date, newErrors, el);
            if (errors?.date?.error) newErrors = errors;
        });
    }
    if (Object.keys(newErrors).length < 1)
        newErrors = checkDiff(newEntry, initialStateOnEntry, newErrors);

    return newErrors;
};
